import React from 'react';
import './Courses.css'

const Courses = () => {
  return (
    <div className='Courses'>
      <h2 className='Courses__header'>Courses</h2>   
      <div className='Courses__line'></div> 
      <div className='Courses__item'>
        <h3 className='Courses__years'>2021 (July - September)</h3>
        <p className='Courses__info'>Preparatory course "JavaScript/Front-end" of RS School.</p>
      </div>
      <div className='Courses__item'>
        <h3 className='Courses__years'>2021 -2022</h3>
        <p className='Courses__info'>Course "JavaScript/Front-end" of RS School.</p>
      </div>
      <div className='Courses__item'>
        <h3 className='Courses__years'>2022 (June - August)</h3>
        <p className='Courses__info'>Course "NodeJs" of RS School.</p>
      </div>
    </div>
  )
}

export default Courses